// Types
import { Column } from '../../manualFlight/objects/column';
import { Preferences } from '../../profile/objects/preferences';
import { ManualFlightFolderState } from '../objects/manualFlightFolderState';
import {
    ADD_PREFERENCES,
    ManualFlightFolderActionTypes,
    MOVE_DOWN_COLUMN,
    MOVE_UP_COLUMN,
    RESET_FILTERS,
    SET_EXPORT_TYPE,
    SET_LIMIT,
    SET_LIST,
    SET_MANUAL_FLIGHT,
    SET_ORDER_BY,
    SET_PAGE,
    SET_PREFERENCES as SET_MANUAL_FLIGHT_FOLDER_PREFERENCES,
    SET_RUNNING,
    SET_SEARCH,
    TOGGLE_COLUMN,
    TOGGLE_EXPORT,
    TOGGLE_EXPORT_FULL,
    TOGGLE_FILTERS,
    TOGGLE_REFRESH,
    UPDATE_FILTER_CREATED_DATE_GTE,
    UPDATE_FILTER_CREATED_DATE_LTE,
    UPDATE_FILTER_CREATOR,
    UPDATE_FILTER_LAST_AUTHOR,
    UPDATE_FILTER_MODIFIED_DATE_GTE,
    UPDATE_FILTER_MODIFIED_DATE_LTE,
    UPDATE_FILTER_PERIOD,
    UPDATE_FILTER_PERIOD_TYPE,
    SET_FLIGHT_FOLDER,
    TOGGLE_REFRESH_MANUAL_FLIGTH
} from './actionTypes';
import { ProfileActionTypes, SET_PREFERENCES } from '../../profile/redux/actionTypes';

const initialState: ManualFlightFolderState = {
    columns: [
    {
        label: 'lead-traveler',
        field_name: 'LEAD_TRAVELER',
        checked: true,
        order_by: '',
        fixed_width: false,
        last_updated: false
    }, {
        label: 'trip-number',
        field_name: 'TRIP_NUMBER',
        checked: true,
        order_by: '',
        fixed_width: false,
        last_updated: false
    }, {
        label: 'number-of-adults',
        field_name: 'NB_ADULT',
        checked: true,
        order_by: '',
        fixed_width: false,
        last_updated: false
    }, {
        label: 'number-of-children',
        field_name: 'NB_CHILD',
        checked: true,
        order_by: '',
        fixed_width: false,
        last_updated: false
    }, {
        label: 'number-of-infants',
        field_name: 'NB_INFANT',
        checked: true,
        order_by: '',
        fixed_width: false,
        last_updated: false
    }, {
        label: 'price',
        field_name: 'PRICE',
        checked: true,
        order_by: '',
        fixed_width: true,
        last_updated: false
    }, {
        label: 'balance',
        field_name: 'OWED_AMOUNT',
        checked: true,
        order_by: '',
        fixed_width: true,
        last_updated: false
    }, {
        label: 'status',
        field_name: 'STATUS',
        checked: true,
        order_by: 'status',
        fixed_width: true,
        last_updated: false
    }, {
        label: 'created-date',
        field_name: 'CREATED_DATE',
        checked: false,
        order_by: 'created_date',
        fixed_width: true,
        last_updated: false
    }, {
        label: 'created-by',
        field_name: 'CREATED_BY',
        checked: false,
        order_by: 'creator__username',
        fixed_width: false,
        last_updated: false
    }, {
        label: 'modified-date',
        field_name: 'MODIFIED_DATE',
        checked: true,
        order_by: 'modified_date',
        fixed_width: true,
        last_updated: false
    }, {
        label: 'modified-by',
        field_name: 'MODIFIED_BY',
        checked: true,
        order_by: 'last_author__username',
        fixed_width: false,
        last_updated: false
    }],
    count: 0,
    export_full: false,
    export_list: false,
    export_type: 'CSV',
    filter_created_date_gte: null,
    filter_created_date_lte: null,
    filter_creator: '',
    filter_last_author: '',
    filter_modified_date_gte: null,
    filter_modified_date_lte: null,
    filter_open: false,
    filter_period: 'CREATION',
    filter_period_type: 0,
    filter_status: 'ALL',
    limit: 50,
    list: null,
    manual_flight: null,
    refresh_manual_flight: false,
    order: 'asc',
    order_by: '-created_date',
    page: 0,
    preferences: [],
    refresh: false,
    running: false,
    search: '',
    flight_folder: null
};

export default (state: ManualFlightFolderState = initialState, action: ManualFlightFolderActionTypes | ProfileActionTypes): ManualFlightFolderState => {
    switch (action.type) {
        case TOGGLE_REFRESH_MANUAL_FLIGTH: {
            return {...state, refresh_manual_flight: !state.refresh_manual_flight};
        }
        case ADD_PREFERENCES: {
            return {...state};
        }
        case MOVE_DOWN_COLUMN: {
            let columns = [...state.columns];
            for (let i = 0; i < columns.length; i++) {
                columns[i].last_updated = false;
            }
            let column = {...columns[action.payload + 1]};
            columns[action.payload + 1] = columns[action.payload];
            columns[action.payload + 1].last_updated = true;
            columns[action.payload] = column;
            return {...state, columns: columns};
        }
        case MOVE_UP_COLUMN: {
            let columns = [...state.columns];
            for (let i = 0; i < columns.length; i++) {
                columns[i].last_updated = false;
            }
            let column = {...columns[action.payload - 1]};
            columns[action.payload - 1] = columns[action.payload];
            columns[action.payload - 1].last_updated = true;
            columns[action.payload] = column;
            return {...state, columns: columns};
        }
        case RESET_FILTERS: {
            return {
                ...state,
                filter_created_date_gte: null,
                filter_created_date_lte: null,
                filter_creator: '',
                filter_last_author: '',
                filter_modified_date_gte: null,
                filter_modified_date_lte: null,
                filter_period: 'CREATION',
                filter_period_type: 0
            }
        }
        case SET_EXPORT_TYPE: {
            return {...state, export_type: action.payload};
        }
        case SET_LIMIT: {
            return {...state, list: null, limit: action.payload};
        }
        case SET_LIST: {
            const { count, results } = action.payload;
            return {...state, count: count, list: results, running: false};
        }
        case SET_MANUAL_FLIGHT: {
            return {...state, manual_flight: action.payload};
        }
        case SET_ORDER_BY: {
            return {...state, list: null, order_by: action.payload, order: state.order_by === action.payload && state.order === 'asc' ? 'desc': 'asc' };
        }
        case SET_PAGE: {
            return {...state, list: null, page: action.payload};
        }
        case SET_PREFERENCES: {
            const preferences = action.payload;
            let new_columns: Column[] = [];
            let new_order_by = '-created_date';
            let new_order: 'asc' | 'desc' = 'asc';
            let field_name: string[] = [];
            let manual_flight_preferences: Preferences[] = [];
            preferences.map(preference => {
                if (preference.module === 'MANUAL_FLIGHT_FOLDER') {
                    if (!field_name.includes(preference.field_name)) {
                        switch (preference.field_name) {
                            case 'LEAD_TRAVELER':
                                new_columns.push({label: 'lead-traveler', field_name: preference.field_name, checked: preference.active, order_by: '', fixed_width: false, last_updated: false});
                                break;
                            case 'TRIP_NUMBER':
                                new_columns.push({label: 'trip-number', field_name: preference.field_name, checked: preference.active, order_by: '', fixed_width: false, last_updated: false});
                                break;
                            case 'NB_ADULT':
                                new_columns.push({label: 'number-of-adults', field_name: preference.field_name, checked: preference.active, order_by: '', fixed_width: false, last_updated: false});
                                break;
                            case 'NB_CHILD':
                                new_columns.push({label: 'number-of-children', field_name: preference.field_name, checked: preference.active, order_by: '', fixed_width: false, last_updated: false});
                                break;
                            case 'NB_INFANT':
                                new_columns.push({label: 'number-of-infants', field_name: preference.field_name, checked: preference.active, order_by: '', fixed_width: false, last_updated: false});
                                break;
                            case 'PRICE':
                                new_columns.push({label: 'price', field_name: preference.field_name, checked: preference.active, order_by: '', fixed_width: true, last_updated: false});
                                break;
                            case 'OWED_AMOUNT':
                                new_columns.push({label: 'balance', field_name: preference.field_name, checked: preference.active, order_by: '', fixed_width: true, last_updated: false});
                                break;
                            case 'STATUS':
                                new_columns.push({label: 'status', field_name: preference.field_name, checked: preference.active, order_by: 'status', fixed_width: true, last_updated: false});
                                new_order_by = preference.ordering_asc !== null ? 'status' : new_order_by;
                                break;
                            case 'CREATED_DATE':
                                new_columns.push({label: 'created-date', field_name: preference.field_name, checked: preference.active, order_by: 'created_date', fixed_width: true, last_updated: false});
                                new_order_by = preference.ordering_asc !== null ? 'created_date' : new_order_by;
                                break;
                            case 'CREATED_BY':
                                new_columns.push({label: 'created-by', field_name: preference.field_name, checked: preference.active, order_by: 'creator__username', fixed_width: false, last_updated: false});
                                new_order_by = preference.ordering_asc !== null ? 'creator__username' : new_order_by;
                                break;
                            case 'MODIFIED_DATE':
                                new_columns.push({label: 'modified-date', field_name: preference.field_name, checked: preference.active, order_by: 'modified_date', fixed_width: true, last_updated: false});
                                new_order_by = preference.ordering_asc !== null ? 'modified_date' : new_order_by;
                                break;
                            case 'MODIFIED_BY':
                                new_columns.push({label: 'modified-by', field_name: preference.field_name, checked: preference.active, order_by: 'last_author__username', fixed_width: false, last_updated: false});
                                new_order_by = preference.ordering_asc !== null ? 'last_author__username' : new_order_by;
                                break;
                            default:
                                break;
                        }
                        manual_flight_preferences.push(preference);
                        field_name.push(preference.field_name);
                        new_order = preference.ordering_asc !== null ? preference.ordering_asc ? 'asc' : 'desc' : new_order;
                    }
                }
            });
            if (new_columns.length !== state.columns.length) {
                state.columns.map(column => {
                    let added = false;
                    for (let i = 0; i < new_columns.length; i++) {
                        if (new_columns[i].label === column.label) {
                            added = true;
                            break;
                        }
                    }
                    if (!added) {
                        new_columns.push({...column});
                    }
                });
            }
            return {...state, preferences: manual_flight_preferences, columns: new_columns, order_by: new_order_by, order: new_order};
        }
        case SET_MANUAL_FLIGHT_FOLDER_PREFERENCES: {
            return state;
        }
        case SET_RUNNING: {
            return {...state, running: action.payload};
        }
        case SET_SEARCH: {
            return {...state, search: action.payload, page: 0};
        }
        case TOGGLE_COLUMN: {
            let columns = [...state.columns];
            let column = {...columns[action.payload]};
            column.checked = !column.checked;
            columns[action.payload] = column;
            return {...state, columns: columns};
        }
        case TOGGLE_EXPORT: {
            return {...state, export_list: action.payload};
        }
        case TOGGLE_EXPORT_FULL: {
            return {...state, export_full: !state.export_full};
        }
        case TOGGLE_FILTERS: {
            return {...state, filter_open: !state.filter_open};
        }
        case TOGGLE_REFRESH: {
            return {...state, refresh: !state.refresh};
        }
        case UPDATE_FILTER_CREATED_DATE_GTE: {
            return {...state, filter_created_date_gte: action.payload};
        }
        case UPDATE_FILTER_CREATED_DATE_LTE: {
            return {...state, filter_created_date_lte: action.payload};
        }
        case UPDATE_FILTER_CREATOR: {
            return {...state, filter_creator: action.payload};
        }
        case UPDATE_FILTER_LAST_AUTHOR: {
            return {...state, filter_last_author: action.payload};
        }
        case UPDATE_FILTER_MODIFIED_DATE_GTE: {
            return {...state, filter_modified_date_gte: action.payload};
        }
        case UPDATE_FILTER_MODIFIED_DATE_LTE: {
            return {...state, filter_modified_date_lte: action.payload};
        }
        case UPDATE_FILTER_PERIOD: {
            const period = action.payload;
            return {
                ...state,
                filter_period: period,
                filter_period_type: 0,
                filter_created_date_gte: period !== 'CREATION' ? null : state.filter_created_date_gte,
                filter_created_date_lte: period !== 'CREATION' ? null : state.filter_created_date_lte,
                filter_modified_date_gte: period !== 'MODIFICATION' ? null : state.filter_modified_date_gte,
                filter_modified_date_lte: period !== 'MODIFICATION' ? null : state.filter_modified_date_lte,
            };
        }
        case UPDATE_FILTER_PERIOD_TYPE: {
            return {...state, filter_period_type: action.payload};
        }
        case SET_FLIGHT_FOLDER: {
            return {...state, flight_folder: action.payload};
        }
        default:
            return state;
    }
};